import { MovexSnackbar } from "@osp-silver/movex-ui"
import { SnackbarProvider, useSnackbar } from "notistack"
import type { ReactNode } from "react";
import { forwardRef } from "react"
import type { ReportCompleteProps } from "./model"

interface SnackbarProviderProps {
  readonly children: ReactNode;
}

const MAX_SNACK = 3;

export const SnackbarStackProvider = ({ children }: SnackbarProviderProps) => (
  <SnackbarProvider
    disableWindowBlurListener
    preventDuplicate
    autoHideDuration={8000}
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
    maxSnack={MAX_SNACK}
    Components={{
      default: SnackbarWrapper,
      info: SnackbarWrapper,
      success: SnackbarWrapper,
      warning: SnackbarWrapper,
      error: SnackbarWrapper,
    }}
  >
    {children}
  </SnackbarProvider>
);

const SnackbarWrapper = forwardRef<HTMLDivElement, ReportCompleteProps>((props, ref) => {
  const { closeSnackbar } = useSnackbar();
  return <MovexSnackbar ref={ref} {...props} closeSnackbar={closeSnackbar} />;
});

SnackbarWrapper.displayName = "SnackbarWrapper";
